import { SideNav } from "components";
import { HomeWrapper } from "components/CdBalance/style";
import { PageTitle } from "components/core";
import React, { useState, useEffect, useMemo } from "react";
import { Checkbox } from "@mui/material";
import routes from "components/routes";
import http from "services/httpService";

import {
  ExclusionBtnDark,
  ExclusionBtnLight,
  ExclusionBtnWrapper,
  ExclusionDivContainer,
  ExclusionDiv,
} from "./v1/PlanOverview/styles";

import { Ptag } from "components/core/fonts";
import { useLocation, useNavigate } from "react-router";
import ProductExclusionModal from "./ProductExclusionModal";

const ProductExclusion = () => {
  const [exclusions, setExclusions] = useState([]);
  const [exclusionsFetched, setExclusionsFetched] = useState(false);
  const [exclusionsUpdated, setExclusionsUpdated] = useState(false);
  const [pageHeading, setPageHeading] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const optedExclusions = {};

  const userplanId = localStorage.getItem("eb_current_plan");
  let selectedValues = localStorage.getItem("eb_selected_values");
  if (selectedValues) {
    selectedValues = JSON.parse(selectedValues);
  }

  const getExistingExclusions = () => {
    try {
      // grades data
      const gradesData = JSON.parse(localStorage.getItem("eb_selected_values"));
      const userPlansData = gradesData.userplans_data[userplanId];
      const allExclusions = userPlansData.userplan_grades_data[0].exclusions;
      if (allExclusions.length > 0) {
        return allExclusions;
      }
      return [];
    } catch (error) {
      console.log("# Error: Old exclusions not found", error);
      return [];
    }
  };

  const boolStatus = (heading, description) => {
    if (
      heading in optedExclusions &&
      optedExclusions[heading] === description
    ) {
      return true;
    }
    return false;
  };

  const getProductExclusions = async () => {
    const { data } = await http.get("/business/get_exclusions_list/");
    const oldExclusions = getExistingExclusions();
    let mergedExclusions = [];

    if (oldExclusions.length > 0) {
      // Merging arrays without duplicates
      mergedExclusions = [...data, ...oldExclusions].filter(
        (item, index, self) =>
          self.findIndex(
            (obj) =>
              obj.heading === item.heading &&
              obj.description === item.description
          ) === index
      );
    } else {
      mergedExclusions = data;
    }

    // save opted exclusions
    for (const each_exclusion of oldExclusions) {
      optedExclusions[each_exclusion.heading] = each_exclusion.description;
    }

    // prepare exclusions checkbox list
    let result = [];
    for (let i = 0; i < mergedExclusions.length; i++) {
      let uniqueId =
        Date.now().toString(36) + Math.random().toString(36).substring(2);
      result.push({
        id: uniqueId,
        heading: mergedExclusions[i].heading,
        description: mergedExclusions[i].description,
        checked: boolStatus(
          mergedExclusions[i].heading,
          mergedExclusions[i].description
        ),
      });
    }
    await setExclusionsFetched(true);
    await setExclusions(result);
  };

  const isPostIssuance = useMemo(() => {
    if (location?.state?.postIssuance) return true;
    return false;
  }, [location]);

  const isFlat = useMemo(() => {
    if (!selectedValues) return false;
    return selectedValues.userplans_data[userplanId]?.flat_or_graded === "FLAT";
  }, [selectedValues]);

  const redirectToGradeSummary = () => {
    if (isPostIssuance) {
      navigate(`/${routes.CARE_DASHBOARD}`);
      return;
    }
    if (!isFlat) {
      // redirect to new grade view
      let userplan_id = localStorage.getItem("eb_current_plan");
      navigate(`/v1/plan-overview/${userplan_id}`,{state:{data:"setup"}});
      return;
    }

    const productType =
      selectedValues.userplans_data[userplanId].product_type.product_type_name;

    if (productType === "health_insurance") {
      //GMC
      navigate(`/${routes.PRE_CORPORATE_BUFFER}`);
    } else if (["top_up_health", "parental_cover"].includes(productType)) {
      navigate(`/${routes.UNIVERSAL_TPA}`);
    } else {
      navigate(`/${routes.UNIVERSAL_COVERAGE_DOC}`);
    }
  };

  const postProductExclusions = async (exclusionObj) => {
    try {
      const { data } = await http.post(
        "business/save_exclusions_list/",
        exclusionObj
      );
      // redirect to summary page
      redirectToGradeSummary();
    } catch (error) {
      console.error("Error:", error.response?.data || error.message);
    }
  };

  const getHeading = () => {
    let eb_current_plan = localStorage.getItem("eb_current_plan");
    let userPlans = JSON.parse(localStorage.getItem("eb_selected_values"));
    let currentPlan = userPlans["userplans_data"][eb_current_plan];
    let title = currentPlan["product_type"]["display_name"];
    setPageHeading(title);
  };

  useEffect(() => {
    if (!exclusionsFetched) {
      getHeading();
      getProductExclusions();
    }
  }, [exclusionsUpdated]);

  const updateExclusion = (obj_id) => {
    for (let x = 0; x < exclusions.length; x++) {
      let each_obj = exclusions[x];
      if (each_obj.id === obj_id) {
        each_obj.checked = !each_obj.checked;
      }
    }
    setExclusionsUpdated(!exclusionsUpdated);
  };

  const exclusionJSX = () => {
    return (
      <>
        <ExclusionDiv>
          {exclusions &&
            exclusions.map((each_obj, key_x) => (
              <ExclusionDivContainer
                key={key_x}
                onClick={() => updateExclusion(each_obj.id)}
              >
                <div>
                  <Checkbox
                    checked={each_obj.checked}
                    sx={{
                      color: "#231A3D !important",
                      padding: 0,
                      "& .MuiSvgIcon-root": { fontSize: 24 },
                    }}
                  />
                </div>
                <div>
                  {/* <Ptag fontSize="18px" fontWeight="600" marginBottom="2px">
                    {each_obj.heading}
                  </Ptag> */}
                  <Ptag fontSize="16px" fontWeight="400">
                    {each_obj.description}
                  </Ptag>
                </div>
              </ExclusionDivContainer>
            ))}

          <ExclusionBtnWrapper>
            <ExclusionBtnLight onClick={handleOpen}>
              {"Add More"}
            </ExclusionBtnLight>
            <ExclusionBtnDark onClick={sendExclusionsForUpdate}>
              {"Save"}
            </ExclusionBtnDark>
          </ExclusionBtnWrapper>
        </ExclusionDiv>
      </>
    );
  };

  const sendExclusionsForUpdate = () => {
    const exclusionObj = {
      exclusions_list: [],
      userplan_id: localStorage.getItem("eb_current_plan"),
    };
    for (let k = 0; k < exclusions.length; k++) {
      let each_obj = exclusions[k];
      if (each_obj.checked) {
        exclusionObj.exclusions_list.push({
          heading: each_obj.heading,
          description: each_obj.description,
        });
      }
    }
    postProductExclusions(exclusionObj);
  };

  return (
    <>
      <SideNav />
      <HomeWrapper>
        <PageTitle title={pageHeading+" Exclusions"} />
        <ProductExclusionModal
          open={open}
          handleOpen={handleOpen}
          handleClose={handleClose}
          setExclusions={setExclusions}
        />
        {exclusionJSX()}
      </HomeWrapper>
    </>
  );
};

export default ProductExclusion;
